import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";
import styles from "./BannerAddonCardFragment.module.css";
import EmptyObject from "@coworker/apprestructured/src/task-management/types/EmptyObject";
import { validateInitialDetailsFieldValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import { Location } from "@coworker/apprestructured/src/task-management/types/SalesLocation";
import {
  RefillQuantityDetail,
  refillQuantityShortLabel,
} from "@coworker/apprestructured/src/task-management/services/refillQuantityLabels";
import ArrowRightSmallIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ArrowRightSmallIconPath";
import { useTranslation } from "@coworker/locales";

export type BannerAddonCardFragmentConfigProps = EmptyObject;

type BannerAddonCardFragmentProps = {
  configProps: BannerAddonCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function BannerAddonCardFragment({
  commonProps,
}: BannerAddonCardFragmentProps) {
  const { task, taskType } = commonProps;
  const { t } = useTranslation();

  const pickupLocation = validateInitialDetailsFieldValue<Location>(
    getByPath(task, "details.pickup_location"),
    "details.pickup_location",
    taskType
  );

  const refillLocation = validateInitialDetailsFieldValue<Location>(
    getByPath(task, "details.refill_location"),
    "details.refill_location",
    taskType
  );

  const refillQuantity = validateInitialDetailsFieldValue<RefillQuantityDetail>(
    getByPath(task, "details.refill_quantity"),
    "details.refill_quantity",
    taskType
  );

  if (
    isLoading(task) ||
    isLoading(taskType) ||
    isLoading(pickupLocation) ||
    isLoading(refillLocation) ||
    isLoading(refillQuantity)
  ) {
    return <LoadingCardFragment />;
  }

  if (!pickupLocation || !refillLocation || !refillQuantity) {
    return null;
  }

  const quantityLabel = refillQuantityShortLabel(refillQuantity, t);
  const pickupLocationLabel = pickupLocation.slid || pickupLocation.custom;
  const refillLocationLabel = refillLocation.slid || refillLocation.custom;

  return (
    <div className={styles["root"]}>
      <FixaText textStyle="Body.M" className={styles["quantity"]}>
        {quantityLabel}
      </FixaText>
      <FixaText textStyle="Body.M" className={styles["location"]}>
        {pickupLocationLabel}
      </FixaText>
      <FixaSSRIcon paths={ArrowRightSmallIconPath} />
      <FixaText textStyle="Body.M" className={styles["location"]}>
        {refillLocationLabel}
      </FixaText>
    </div>
  );
}

export default BannerAddonCardFragment;
